import React from 'react';

import {
  formatCurrency,
  formatDateTimeView, isEmpty,
  isEmptyObject,
} from '../../../../../utils/utils';
import DateTimePick from './DateTimePick';
import { trans } from '../../../../../localization/index';
import {
  EnumDeliveryByType,
  EnumPaymentMethod,
  EnumShippingMethod,
} from '../../../../../constants/enum';

export const GroupOrderView = ({ className = '', title, children }) => (
  <div className={`${className} mt-2`}>
    <strong className="text-red">{title}</strong>
    <div className="p-2">{children}</div>
  </div>
);

export const GroupItemOrderView = ({ title, children }) => (
  <div className="row mb-1">
    <div className="col-1">{title}:</div>
    <div className="col-9">
      <strong>{children}</strong>
    </div>
  </div>
);

function TimeDeliveryView({ deliverTime }) {
  return (
    <span>
      (
      <span>{trans('mod_detail_hour_of_delivery')}:</span>
      <strong
        style={{
          color: '#ee4d2d',
          textDecoration: 'underline',
          marginLeft: '5px',
        }}
      >
        {formatDateTimeView(deliverTime)}
      </strong>
      )
    </span>
  );
}

function PickTimeView({ pickTime, isPickup }) {
  const descriptionPickTime = isPickup
    ? 'mod_detail_order_time_pickup'
    : 'mod_detail_restaurant_appointment_shipper';
  return (
    <React.Fragment>
      <strong className="mr-1">{trans(descriptionPickTime)}</strong>
      <strong
        className="text-red"
        style={{
          textDecoration: 'underline',
        }}
      >
        {formatDateTimeView(pickTime)}
      </strong>
    </React.Fragment>
  );
}

function AssigneeInfoView({ assignee }) {
  return (
    <div>
      <span>
        <b>{trans('mod_detail_delivery_by')}</b>: {assignee.name}
      </span>
      {/* {!isEmptyObject(assignee.phone) && (
        <div>
          <b>{trans('mod_detail_telephone_number_of_shipper')}</b>:{' '}
          {assignee.phone}
        </div>
      )} */}
    </div>
  );
}

function CustomerInfoView({ customer }) {
  const { name } = customer;
  return (
    <GroupOrderView title={trans('mod_receiver_info')}>
      <GroupItemOrderView title={trans('mod_customer_name')}>
        {name}
      </GroupItemOrderView>
      {/* <GroupItemOrderView title={trans('mod_customer_phone')}>
        {phone}
      </GroupItemOrderView> */}
    </GroupOrderView>
  );
}

function DeliveryInfoView({ deliverAddress, customerBill, customerPay }) {
  const { contact_name } = deliverAddress;
  const { type: paymentType } = customerPay;
  const {
    total_amount: totalAmount,
    shipping_fee: shippingFee,
    service_fee: serviceFee,
  } = customerBill;
  return (
    <GroupOrderView title={trans('mod_receiver_info')}>
      <GroupItemOrderView title={trans('mod_customer_name')}>
        {contact_name}
      </GroupItemOrderView>
      {/* <GroupItemOrderView title={trans('mod_customer_phone')}>
        {phone}
      </GroupItemOrderView>
      <GroupItemOrderView title={trans('mod_customer_address')}>
        {address}
      </GroupItemOrderView> */}
      <GroupItemOrderView title={trans('mod_customer_collect_amount')}>
        <span className="text-danger">{formatCurrency(totalAmount)}</span>
        {` - ${trans('mod_customer_collect_amount_about')} (`}
        <span className="text-blue">{formatCurrency(shippingFee)}</span>
        {` ${trans('mod_customer_distance_fee')}, `}
        <span className="text-blue">{formatCurrency(serviceFee)}</span>{' '}
        {` ${trans('mod_customer_service_fee')})`}
      </GroupItemOrderView>
      <GroupItemOrderView title={trans('mod_customer_pay_by')}>
        {trans(
          paymentType === EnumPaymentMethod.COD.id
            ? 'mod_collect_guest_money'
            : 'mod_not_receivable',
        )}
      </GroupItemOrderView>
    </GroupOrderView>
  );
}

function OrdererInfoView({ orderer }) {
  const { name, phone } = orderer;
  return (
    <GroupOrderView title={trans('mod_orderer_info')}>
      <GroupItemOrderView title={trans('mod_customer_name')}>
        {name}
      </GroupItemOrderView>
      <GroupItemOrderView title={trans('mod_customer_phone')}>
        {phone}
      </GroupItemOrderView>
    </GroupOrderView>
  );
}

function DeliveryInfoVat({ vat }) {
  const { company_name: companyName, address, tax_number: taxNumber } = vat;
  return (
    <GroupOrderView title={trans('mod_vat_info')}>
      <GroupItemOrderView title={trans('mod_vat_company_name')}>
        {companyName}
      </GroupItemOrderView>
      <GroupItemOrderView title={trans('mod_vat_address')}>
        {address}
      </GroupItemOrderView>
      <GroupItemOrderView title={trans('mod_vat_tax_number')}>
        {taxNumber}
      </GroupItemOrderView>
    </GroupOrderView>
  );
}

export function OrderDetailInfo({
  isHaveChangeOrder,
  itemDetail,
  merchantNote,
  pickTime,
  handleChangePickTime,
  handleChangeMerchantNote,
}) {
  const {
    note,
    cs_note: csNote,
    deliver_time: deliverTime,
    assignee,
    customer,
    shipping,
    delivery_by: deliveryBy,
    deliver_address: deliverAddress,
    vat,
    customer_bill: customerBill,
    customer_pay: customerPay = {},
    order_user: orderUser = {},
  } = itemDetail;
  const isPickup =
    !isEmptyObject(shipping) && shipping.type === EnumShippingMethod.PICKUP.id;
  const isShowInfoDelivery =
    !isEmptyObject(deliverAddress) &&
    !isPickup &&
    deliveryBy === EnumDeliveryByType.MERCHANT.id;
  const isShowOrdererInfo = (
    !isEmpty(orderUser.phone) && orderUser.phone !== deliverAddress.phone
  );

  return (
    <div className="pl-3 pr-3">
      <div>
        {!isEmptyObject(note) && (
          <span>
            <b>{trans('mod_detail_customer_note')}</b>: {note}
          </span>
        )}
        {!isEmptyObject(csNote) && (
          <span>
            <b>{trans('rebranding.mod_detail_now_note')}</b>: {csNote}
          </span>
        )}
      </div>
      <div>
        <span>{trans('rebranding.mod_note_for_now')}: </span>
        {isHaveChangeOrder ? (
          <textarea
            name="merchantNote"
            placeholder={trans('mod_detail_restaurant_note')}
            className="w-100"
            value={merchantNote}
            onChange={handleChangeMerchantNote}
          />
        ) : (
          <span>{merchantNote}</span>
        )}
      </div>
      <hr />
      <div>
        {!isHaveChangeOrder ? (
          <PickTimeView pickTime={pickTime} isPickup={isPickup} />
        ) : (
          <DateTimePick
            value={pickTime}
            onChange={handleChangePickTime}
            isPickup={isPickup}
          />
        )}
      </div>
      {!isPickup && <TimeDeliveryView deliverTime={deliverTime} />}
      {!isEmptyObject(assignee) && <AssigneeInfoView assignee={assignee} />}
      {isPickup && <CustomerInfoView customer={customer} />}
      {isShowInfoDelivery && (
        <DeliveryInfoView
          deliverAddress={deliverAddress}
          customerBill={customerBill}
          customerPay={customerPay}
        />
      )}
      {isShowOrdererInfo && <OrdererInfoView orderer={orderUser} />}
      {!isEmptyObject(vat) && <DeliveryInfoVat vat={vat} />}
    </div>
  );
}


// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OrderDetailInfo.jsx